class SettingApi {
  static async getAll() {
    const url = '/api/settings'
    const response = await http('get', url, {})
    return response?.data || {}
  }
}

export default SettingApi
